/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-21 10:49:35
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import { DateRangeType, DateSelect } from '../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from '../../../models/datetime'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './recordOfAdverseReactions.module.css'

const { Option } = Select

export const Query = (props: {
  add: () => void
  onValueChange: (params: any) => void
  export: () => void
  loading?: any
  exportLoading?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const { RangePicker } = DatePicker

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  const [timeList, setTimeList] = useState<any>()

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])
  
  useEffect(() => {
    setTimeList([moment().startOf('day'), moment().endOf('day')])
    form.setFieldsValue({
      time: [moment().startOf('day'), moment().endOf('day')],
    })
    form.submit()
  }, [])

  const disabledDate: any = (current: any) => {
    return timeList?.[0]
      ? moment(current)?.format('yyyy') != moment(timeList?.[0])?.format('yyyy')
      : false
  }

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        if(!values?.timeHead && values?._dateRange == 6){
          return
        }
        const startTime = moment(values?.timeHead)?.format(
          DateTimeFormatSimpleOnly
        )
        const endTime = moment(values?.timeTail)?.format(
          DateTimeFormatSimpleOnly
        )
        props.onValueChange({
          ...values,
          createTimeStart: startTime,
          createTimeEnd: endTime,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%', height: '42px' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          {/* <Form.Item name='time' noStyle>
            <RangePicker
              format={DateTimeFormatSimple}
              style={{ width: '16em' }}
              disabledDate={disabledDate}
              onCalendarChange={(v: any) => {
                setTimeList(v)
              }}
            />
          </Form.Item> */}
          <DateSelect
            allowClear={false}
            style={{ width: '8rem' }}
            labelPrefix=''
            placeholder='创建时间'
            namePrefix='time'
            initialValue={DateRangeType.Today}
            onChange={() => {
              form.submit()
            }}
          />
          <Form.Item name='reportUserName' noStyle>
            <Input
              style={{ width: '150px' }}
              allowClear={true}
              placeholder='记录员'
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.select}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              props?.add && props?.add()
            }}
          >
            添加
          </Button>
          <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export && props?.export()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
